import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MakeBuyService, PartService, PartSourceService } from '../../../../phf.service';
import { PartDetailService } from '../part-detail.service';
import { Subscription, Subject } from 'rxjs';
import { FilterableService } from '../../../../../mesc/filterable-service';
import { PartListService } from '../../part-list.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'general-tab',
    templateUrl: './general-tab.component.html',
    styleUrls: ['../part-detail.component.scss']
})
export class GeneralTabComponent implements OnInit {
    part: any;
    editForm: FormGroup;
    isEditing: boolean;
    isLoading = false;
    subscription: Subscription;
    private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
    partWeightList: any[] = [];
    partSizeList: any[] = [];
    materialService: FilterableService = new FilterableService();
    makeBuyService: FilterableService = new FilterableService();
    partTypeService: FilterableService = new FilterableService();

    @Input()
    set data(dataItem: any) {
        if (dataItem) {
            this.part = dataItem;
        }
    }

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly partListService: PartListService,
        private readonly phfMakeBuyService: MakeBuyService,
        private readonly partService: PartService,
        public readonly messageService: PartDetailService,
        private readonly partSourceService: PartSourceService,
    ) {
        this.subscription = this.messageService.getMessage()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(message => {
                this.isEditing = message.editing;
            });
    }

    ngOnInit() {
        this.editForm = this.formBuilder.group(GeneralEditForm);
        this.editForm.get('IsActive').setValue(true);
        this.messageService.partDataObject = this.editForm;

        this.materialService = this.partListService.lookupData.MaterialViewDto;
        this.partTypeService = this.partListService.lookupData.PartTypeViewDto;

        this.isLoading = true;
        Promise.all([
            this.phfMakeBuyService.read()
                .then(x => this.makeBuyService.next(x)),
            this.partSourceService.read()
                .then(result => {
                    this.partWeightList = Object.assign([], result);
                    const test = this.partWeightList.find(x => x.Description === 'DOL')
                    this.partWeightList.splice(this.partWeightList.indexOf(test), 1)

                    this.partSizeList = Object.assign([], result);
                    const tester = this.partSizeList.find(x => x.Description === 'MPS')
                    this.partSizeList.splice(this.partSizeList.indexOf(tester), 1)
                }),
        ])
            .then(() => { this.refreshInfo(); })
            .catch(e => { this.isLoading = false })
    }


    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    onKeyUp = (e) => {
        if (isNaN(e.target.valueAsNumber)) {
            try {
                e.target.value = parseInt(e.target.value);
            } catch (e) {
                e.target.value = '';
            }
        }
    }

    private readonly formControlHandlers = {
        MaterialId: (value) => this.handleMaterialChange(value),
        MakeBuyId: (value) => this.handleMakeBuyChange(value),
        SourceOfPartWeight: (value) => this.handlePartWeightSourceChange(value),
        SourceOfPartSize: (value) => this.handlePartSizeSourceChange(value),
        PartTypeId: (value) => this.handlePartTypeChange(value),
    }

    private refreshFormHandler(name: string) {
        const ctrl = this.editForm.get(name);
        if (ctrl && ctrl.value) {
            this.formControlHandlers[name](ctrl.value);
        }
    }

    private refreshInfo() {
        if (this.part && this.part.Id) {
            this.partService.read('/' + this.part.Id)
                .then(partResult => {
                    if (partResult) {
                        this.editForm.reset(partResult);
                        this.refreshFormHandler('MaterialId');
                        this.refreshFormHandler('MakeBuyId');
                        this.refreshFormHandler('SourceOfPartWeight');
                        this.refreshFormHandler('SourceOfPartSize');
                        this.refreshFormHandler('PartTypeId');
                    }
                    this.isLoading = false;
                });
        } else {
            this.isLoading = false;
        }
    }

    handleMaterialChange = (dataItem) => {
        const material = this.materialService.value.find(x => x.Id === dataItem)
        this.editForm.get('MaterialType').setValue(material ? material.Type : '');
    }

    handleMakeBuyChange = (dataItem) => {
        const makeBuy = this.makeBuyService.value.find(x => x.Id === dataItem);
        this.editForm.get('MakeBuyType').setValue(makeBuy ? makeBuy.Type : '');
    }

    handlePartWeightSourceChange = (dataItem) => {
        const partWeightSource = this.partSourceService.value.find(x => x.Id === dataItem);
        this.editForm.get('SourceOfPartWeightName').setValue(partWeightSource ? partWeightSource.Name : '');
    }

    handlePartSizeSourceChange = (dataItem) => {
        const partSizeSource = this.partSourceService.value.find(x => x.Id === dataItem);
        this.editForm.get('SourceofPartSizeName').setValue(partSizeSource ? partSizeSource.Name : '');
    }

    handlePartTypeChange = (dataItem) => {
        const partType = this.partTypeService.value.find(x => x.Id === dataItem);
        this.editForm.get('PartType').setValue(partType ? partType.Description : '');
    }

}

const GeneralEditForm = {
    Id: [],
    WeightMetric: [],
    PitchLengthMetric: [],
    WidthMetric: [],
    Code: [],
    Number: [],
    Name: [],
    Weight: [],
    PitchLength: [],
    Width: [],
    Thickness: [],
    ImageTeamcenterURL: [],
    Assembly: [],
    PressId: [],
    ToolSetId: [],
    ContainerId: [],
    ProgramId: [],
    ProgramName: [],
    PlantName: [],
    MaterialId: [],
    MakeBuyId: [],
    PartLoadingId: [],
    IsActive: [],
    MaterialType: [],
    MakeBuyType: [],
    SourceOfPartWeight: [],
    SourceOfPartWeightName: [],
    SourceOfPartSize: [],
    SourceofPartSizeName: [],
    PartTypeId: [],
    PartType: [],
    AttachmentId: [],
    AttachmentPath: [],
    AttachmentFileName: [],
    ProgramAssemblyPlant: [],
    UPC: [],
    FNA: [],
    MaterialSpecification: []
}
